import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import FormModal from "../Modal";
import axios from "axios";
import { notify } from "../../utils/toast";
import "react-phone-number-input/style.css";
import PhoneInput, {
  formatPhoneNumber,
  formatPhoneNumberIntl,
  isValidPhoneNumber,
} from "react-phone-number-input";

const url = `${process.env.REACT_APP_SERVER_BASE_URL}/form/submit`;

function ContactForm({ handleCloseForm }) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [whatsappNumber, setWhatsappNumber] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    if (name === "" || whatsappNumber === "" || email === "") {
      notify.error("Please complete all input fields.");
    } else {
      try {
        let URL = `${url}`;
        const response = await axios.post(url, {
          name,
          whatsappNumber,
          email,
        });
        // console.log("Success:", response);
        if (response?.data?.success) {
          handleCloseForm();
          notify.success("Form submitted successfully.");
        }
      } catch (error) {
        notify.error(
          error?.response?.data?.message ||
            error?.message ||
            "something went wrong"
        );
        console.error("Error:", error);
      }
    }
  }

  return (
    <div className="row text-center">
      <div className="contact-form m-0" id="contact">
        <form onSubmit={(e) => handleSubmit(e)}>
          <div className="head">
            <h2>Join The Movement</h2>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="form-group mb-4">
                <label className="mb-2">Full Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Full Name"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="form-group mb-4">
                <label className="mb-2">Email Address</label>
                <input
                  type="email"
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email Address"
                />
              </div>
            </div>
            <div className="col-12">
              <div className="form-group mb-4 phone">
                <label className="mb-2">WhatsApp Number</label>
                {/* <input
                  type="number"
                  className="form-control"
                  value={whatsappNumber}
                  onChange={(e) => setWhatsappNumber(e.target.value)}
                  placeholder="WhatsApp Number"
                /> */}
                <PhoneInput
                  className="form-control"
                  international
                  countryCallingCodeEditable={false}
                  value={whatsappNumber}
                  onChange={setWhatsappNumber}
                  placeholder="Whatsapp Number"
                />
              </div>
            </div>
          </div>
          <Button type="submit" className="btn mb-4">
            {" "}
            Submit{" "}
          </Button>
          {/* <FormModal btnText= {"Submit"} message= {"Thankyou we have recieve your message and the team of Technology Movement Pakistan will contact you info"} /> */}
          {/* <button className='btn'>Submit</button> */}
        </form>
      </div>
    </div>
  );
}

export default ContactForm;
